import { useId } from "react"

interface LandingIconVerifiedCheckProps {
  className?: string
  /**
   * CSS color value to use for the check mark fill. Defaults to `currentColor`, so Tailwind text-color utilities (e.g. `text-blue-500`) will automatically style the icon.
   */
  color?: string
}

export function LandingIconVerifiedCheck({ className, color = "currentColor" }: LandingIconVerifiedCheckProps) {
  const clipId = useId()

  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Verified</title>
      <g clipPath={`url(#${clipId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.26 2.25L8.94 0L6.62 2.25L3.42 1.8L2.86 4.98L0 6.5L1.42 9.4L0 12.3L2.86 13.82L3.42 17L6.62 16.55L8.94 18.8L11.26 16.55L14.46 17L15.02 13.82L17.88 12.3L16.46 9.4L17.88 6.5L15.02 4.98L14.46 1.8L11.26 2.25ZM4.17 9.83L7.6 13.26L13.28 7.05L11.93 5.8L7.53 10.6L5.46 8.53L4.17 9.83Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="17.88" height="18.8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
